import React, { useEffect, useState } from 'react'
import "../css/HomePage.css"
import NewImageSlider from '../components/NewImageSlider';
import HomePageGridImage from '../components/HomePageGridImage';
import HomePageSvgShape from '../components/HomePageSvgShape';

const Homepage = () => {

  return (
    <div style={{ color: "black" }}>
      <NewImageSlider />
      <HomePageGridImage />
      <HomePageSvgShape />
    </div >
  );
};

export default Homepage